import { merge } from '../../helper';

import * as exInput from '../input';
import * as exElement from '../../utils/element';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {
        inline: false,
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const elements: Record<string, any> = {};

    // Create element (checkbox)
    const elCheckbox = exElement.create({
        merge: defConfig.checkbox,
        class: {
            new: 'form-check',
        },
    });
    elements.element = elCheckbox;

    // ------------------------------------------------------------------------

    //
    const inputName = defConfig.name ?? defConfig.input.name;

    // Create element (input)
    const input = exInput.create({
        merge: defConfig.input,
        type: 'checkbox',
        class: {
            new: 'form-check-input',
        },
        attr: {
            id: inputName,
            name: inputName,
        },
    });
    elCheckbox.appendChild(input.element);
    elements.input = input;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // If using inline
    if (config.inline === true) {
        elements.element.addClass('form-check-inline');
    }

    // If using checkmark
    if (config.checkmark === true) {
        // Add class (checkbox mark)
        elements.element.addClass('checkbox-mark');

        // Create element (span)
        const elSpan = exElement.create({
            merge: config.span,
            tag: 'span',
            class: {
                new: 'checkmark',
            },
        });
        elements.element.appendChild(elSpan);
    }

    // If using checked
    if (config.input?.checked === true) {
        elements.input.element.checked = true;
    }

    // If using label
    if (config.label != null || config.html != null) {
        // Create element (label)
        const elLabel = exElement.create({
            merge: config.label,
            tag: 'label',
            class: {
                new: 'form-check-label checkbox-label',
            },
            html: config.html,
            container: {
                parent: elements.element,
            },
        });
        elements.label = elLabel;
    }

    // If using relate
    if (config.label != null && config.label.relate !== false) {
        elements.label.setAttribute('for', elements.input.element.id);
    }
}

// ----------------------------------------------------------------------------

export { create };
